module.exports = __webpack_public_path__ + "static/media/Stellar Neo Single Headboard - 120 cm_Black.496d48bd.png";